/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {RatioRoomingListBed, RatioRoomingListGuest} from '../../../../models/reports.model'
import {
  getRatioRoomingListTotalCSVService,
  getRatioRoomingListTotalExcelService,
  getRatioRoomingListTotalPDFService,
  getRatioRoomingMainTotalesService,
} from '../../../../services/ratio.service'

interface BedGuestProps {
  // dataBed: RatioRoomingListBed[]
  // dataGuest: RatioRoomingListGuest[]
  // loading: boolean
  formValue: any
}

interface BedProps {
  dataBed: RatioRoomingListBed[]
  loading: boolean
  formValue: any
}

interface GuestProps {
  dataGuest: RatioRoomingListGuest[]
  loading: boolean
  formValue: any
}

const TableReportRatioRoomingListBed: FC<BedProps> = ({dataBed, loading, formValue}) => {
  const columns: Column<RatioRoomingListBed>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Resumen de Camas' />,
      accessor: 'Resumen',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'Cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Porcentaje' />,
      accessor: 'Porcentaje',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        {/* <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div> */}
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={dataBed} columns={columns} showPagination={false} />
      </KTCard>
    </>
  )
}

const TableReportRatioRoomingListGuest: FC<GuestProps> = ({dataGuest, loading, formValue}) => {
  const columns: Column<RatioRoomingListGuest>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Resumen de Huespedes' />,
      accessor: 'Resumen',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'Cantidad',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        {/* <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div> */}
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={dataGuest} columns={columns} showPagination={false} />
      </KTCard>
    </>
  )
}

const TableReportRatioRoomingListBedWrapper: FC<BedProps> = ({dataBed, loading, formValue}) => {
  return (
    <KTableProvider>
      <TableReportRatioRoomingListBed dataBed={dataBed} loading={loading} formValue={formValue} />
      <SnackbarProvider />
    </KTableProvider>
  )
}

const TableReportRatioRoomingListGuestWrapper: FC<GuestProps> = ({
  dataGuest,
  loading,
  formValue,
}) => {
  return (
    <KTableProvider>
      <TableReportRatioRoomingListGuest
        dataGuest={dataGuest}
        loading={loading}
        formValue={formValue}
      />
      <SnackbarProvider />
    </KTableProvider>
  )
}

const TableReportRatioRoomingListBedGuest: FC<BedGuestProps> = ({
  // dataBed,
  // dataGuest,
  // loading,
  formValue,
}) => {
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)
  const [dataBed, setDataBed] = useState<RatioRoomingListBed[]>([])
  const [dataGuest, setDataGuest] = useState<RatioRoomingListGuest[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const getMainRoomTotals = async () => {
    setLoading(true)
    try {
      const {data: response} = await getRatioRoomingMainTotalesService(formValue)
      let arrBeds: RatioRoomingListBed[] = [
        {
          Resumen: 'Total Camas (C.I + C.C)',
          Cantidad: response.TotalCamas,
          Porcentaje: response.TotalCamasPorc,
        },
        {
          Resumen: 'Total Ocupadas (C.I + C.C)',
          Cantidad: response.TotalCamasOcupadas,
          Porcentaje: response.TotalCamasOcupadasPorc,
        },
        {
          Resumen: 'Total Disponibles',
          Cantidad: response.TotalCamasDisponibles,
          Porcentaje: response.TotalCamasDisponiblesPorc,
        },
        {
          Resumen: 'Total Salidas Programadas',
          Cantidad: response.TotalSalidasProgramadas,
          Porcentaje: '',
        },
        {
          Resumen: 'Total Continuan Programadas',
          Cantidad: response.TotalContinuanProgramadas,
          Porcentaje: '',
        },
        {
          Resumen: 'Total Sucias',
          Cantidad: response.TotalCamasSucias,
          Porcentaje: response.TotalCamasSuciasPorc,
        },
        {
          Resumen: 'Total Bloqueadas',
          Cantidad: response.TotalCamasBloqueadas,
          Porcentaje: response.TotalCamasBloqueadasPorc,
        },
        {
          Resumen: 'Total Reservadas',
          Cantidad: response.TotalCamasReservadas,
          Porcentaje: response.TotalCamasReservadasPorc,
        },
      ]
      setDataBed(arrBeds)
      let arrGuest: RatioRoomingListGuest[] = [
        {
          Resumen: 'Nro. de Huespedes',
          Cantidad: response.CantHuesped,
        },
        {
          Resumen: 'Huespedes Salientes con salida programada',
          Cantidad: response.CantHuespedSalientes,
        },
        {
          Resumen: 'Huespedes que permanecen en el campamento',
          Cantidad: response.CantHuespedContinuan,
        },
      ]
      setDataGuest(arrGuest)
    } catch (error) {
      console.error('Error fetching main room totals:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getMainRoomTotals()
  }, [])

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getRatioRoomingListTotalExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Rooming Total-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getRatioRoomingListTotalCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Rooming Total-${moment().format('DD/MM/YY HH:mm').toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getRatioRoomingListTotalPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Rooming Total-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  return (
    <>
      <div className='d-flex justify-content-end p-2 me-5'>
        <button
          type='button'
          className='btn btn-success me-3'
          disabled={dataBed.length < 1 || isDownloadXLS}
          onClick={handleExportXLS}
        >
          {isDownloadXLS && (
            <div className='icon-container'>
              <i className='loader'></i>
            </div>
          )}
          Descargar Excel
        </button>
        <button
          type='button'
          className='btn btn-success me-3'
          disabled={dataBed.length < 1 || isDownloadCSV}
          onClick={handleExportCSV}
        >
          {isDownloadCSV && (
            <div className='icon-container'>
              <i className='loader'></i>
            </div>
          )}
          Descargar CSV
        </button>
        <button
          type='button'
          className='btn btn-success me-3'
          disabled={dataBed.length < 1 || isDownloadPDF}
          onClick={handleExportPDF}
        >
          {isDownloadPDF && (
            <div className='icon-container'>
              <i className='loader'></i>
            </div>
          )}
          Descargar PDF
        </button>
      </div>
      <TableReportRatioRoomingListBedWrapper
        dataBed={dataBed}
        loading={loading}
        formValue={formValue}
      />
      <TableReportRatioRoomingListGuestWrapper
        dataGuest={dataGuest}
        loading={loading}
        formValue={formValue}
      />
    </>
  )
}

export {TableReportRatioRoomingListBedGuest}
